import React from 'react';

export default function ChatSources({ context }) {
  if (!['global', 'fulltext'].includes(context?.mode)) return null;
  const sources = context.sources || [];
  return (
    <div className="chat-sources">
      <span className="chat-sources__label">{context.indexed_papers || 0} papers searched</span>
      {context.unavailable_papers?.length > 0 && (
        <p role="status">Full text unavailable: {context.unavailable_papers.join('; ')}</p>
      )}
      {sources.length > 0 && (
        <details>
          <summary>Source evidence ({sources.length})</summary>
          {sources.map((source) => (
            <div key={source.id} className="chat-sources__item">
              <strong>[{source.id}] {source.paper}</strong>
              {source.page && <span>p. {source.page}</span>}
            </div>
          ))}
        </details>
      )}
    </div>
  );
}
